import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logos/DBHubsTextLogo.png'
import _imports_1 from '../assets/logos/socials/discord.png'
import _imports_2 from '../assets/logos/socials/yt.png'
import _imports_3 from '../assets/logos/socials/tiktok.png'


const _withScopeId = n => (_pushScopeId("data-v-52c5ac11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "outer-wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-topper" }
const _hoisted_4 = { class: "logo-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  id: "logo-text"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"socials-container\" data-v-52c5ac11><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"socials\" href=\"https://discord.gg/dbhubsrl\" data-v-52c5ac11><img class=\"socials-img\" src=\"" + _imports_1 + "\" data-v-52c5ac11></a><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"socials\" href=\"https://www.instagram.com/dbhubsofficial/\" data-v-52c5ac11><img class=\"socials-img\" src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/900px-Instagram_icon.png?20200512141346\" data-v-52c5ac11></a><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"socials\" href=\"https://youtube.com/@DBhubs?feature=shared\" data-v-52c5ac11><img class=\"socials-img\" src=\"" + _imports_2 + "\" data-v-52c5ac11></a><a target=\"_blank\" rel=\"noopener noreferrer\" class=\"socials\" href=\"https://www.tiktok.com/@dbhubsofficial?_t=8m8rVRIApNS&amp;_r=1\" data-v-52c5ac11><img class=\"socials-img\" src=\"" + _imports_3 + "\" data-v-52c5ac11></a></div>", 1)
const _hoisted_7 = { class: "footer-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "footer-category-title" }, "Pages", -1))
const _hoisted_9 = { class: "pages-wrapper" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"other-container\" data-v-52c5ac11><h3 class=\"footer-category-title\" data-v-52c5ac11>Socials</h3><div data-v-52c5ac11><a target=\"_blank\" class=\"hover-color\" rel=\"noopener noreferrer\" href=\"https://discord.gg/dbhubsrl\" data-v-52c5ac11>Join the free section on our Discord!</a><a target=\"_blank\" class=\"hover-color\" rel=\"noopener noreferrer\" href=\"https://www.instagram.com/dbhubsofficial/\" data-v-52c5ac11>Follow us on Instagram</a><a target=\"_blank\" class=\"hover-color\" rel=\"noopener noreferrer\" href=\"https://www.youtube.com/@DBhubsRL\" data-v-52c5ac11>Subscribe to our YouTube</a><a target=\"_blank\" class=\"hover-color\" rel=\"noopener noreferrer\" href=\"https://www.tiktok.com/@dbhubs?lang=en\" data-v-52c5ac11>Subscribe on TikTok</a></div></div>", 1)
const _hoisted_11 = { class: "footer-bottom" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "© 2024 DBhubs. All rights reserved.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "logo"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", null, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, {
              class: "hover-color",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Home")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/coaches",
              class: "hover-color"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Coaches")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/join",
              class: "hover-color"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Sign up")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/testimonials",
              class: "hover-color"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Testimonials")
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/faq",
              class: "hover-color"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Help / FAQ")
              ]),
              _: 1
            })
          ])
        ]),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_router_link, {
          to: "/attributions",
          class: "hover-color"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Attributions")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}